import {combineReducers} from 'redux'
import {LINKS_LOADED, PROVIDER_LOADED, PROVIDER_RESET} from './actions'

const provider = (function() {

    function provider(state = null, action) {
        switch (action.type) {
            case PROVIDER_LOADED:
                return action.provider
            case PROVIDER_RESET:
                return null
            default:
                return state
        }
    }

    return combineReducers({provider})
})()

export default combineReducers({
    provider
})


// WEBPACK FOOTER //
// ./lib/actradis/reducers.js